import HardSkills from './HardSkills'
export default HardSkills
